import React from "react"
import PropTypes from "prop-types"
import { Button } from "react-bootstrap"

export const BulkActionsCancelButton = (props) => (
    <Button
        className="bulk-actions-console-button bulk-actions-buttons-cancel btn-block"
        data-cy="bulk-actions-buttons-cancel"
        onClick={() => {
            // unmounts BulkActionsConsole and de-selects the SearchActionsButtons button
            props.setActiveActionButton(props.uniqueFlvId, undefined)
        }}
        variant="default"
    >
        Cancel
    </Button>
)

BulkActionsCancelButton.propTypes = {
    // from shared/search/action-creators
    setActiveActionButton: PropTypes.func.isRequired,
    // from app/static/frontend/search-new/components/BulkActions/BulkActionsConsole
    // actually the onSubmit() from shared/forms/BulkActions/action-creators
    uniqueFlvId: PropTypes.string.isRequired,
}

export default BulkActionsCancelButton
